import { Link } from 'react-router';
import type { FilterOption } from 'types/capi/plp';

import useSortInteraction from '~/hooks/useSortInteraction';
import gtm from '~/services/gtm.client';

type Props = {
  options: FilterOption[];
};

const FilterOptions = ({ options }: Props) => {
  const fireSortInteraction = useSortInteraction();

  const defaultClasses =
    'rounded-full border border-grey-hide text-grey-hide text-sm md:py-2';
  const selectedClasses = 'bg-black text-white border-none py-1';

  function onClick(item: FilterOption) {
    gtm.sendPlpProductFilterEvent({
      filterName: item.text,
      filterValue: item.text,
      pagePosition: 'Top Bar'
    });

    fireSortInteraction(item.sort_key, 'filter_bar');
  }

  return (
    <div className="flex w-full justify-center gap-2 md:w-[264px] md:justify-end">
      {options.map((item) => {
        return (
          <Link
            onClick={() => onClick(item)}
            rel="nofollow"
            to={item.path}
            className={`flex h-8 w-full items-center justify-center md:h-10 md:max-w-24 ${defaultClasses} ${
              item.active ? selectedClasses : ''
            }`}
            key={item.path}
          >
            {item.text}
          </Link>
        );
      })}
    </div>
  );
};

export default FilterOptions;
